export default {
  rooms: {},
  myRooms: {},
  profanitiesNotification: null,
  roomGifts: null,
//  roomChats: {
//    messages: {},
//  },
};
